<template>
	<div class="w-full" :class="[canShow ? '' : 'hidden']">
		<div class="mb-3 flex justify-between">
			<span class="mb-0 font-medium text-gray-650">{{ title }}</span>
			<span
				v-if="activeFilters[facetKey] && activeFilters[facetKey].length"
				class="cursor-pointer text-sm text-gray-600 underline hover:text-blue-400"
				@click="onClear"
			>
				Clear
			</span>
		</div>

		<div class="m-0 space-y-3 p-0">
			<template
				v-for="(facetItem, index) in visibleFacetItems.slice(
					0,
					accordionThreshold
				)"
				:key="index"
			>
				<CheckboxFacetItem
					:facet-key="facetKey"
					:facet-item="facetItem"
					class="flex justify-between"
				/>
			</template>
		</div>

		<ClientOnly>
			<SlideDownAccordion
				v-if="visibleFacetItems.length > accordionThreshold"
				:disclosure-button-at-bottom="true"
				class="mt-3"
				:button-class="'text-sm text-gray-600 underline decoration-gray-600'"
				:opened-label="accordionOpenedLabel"
				:closed-label="accordionClosedLabel"
			>
				<template #disclosure-panel>
					<div class="mb-3 mt-0 space-y-3 p-0">
						<template
							v-for="(
								facetItem, index
							) in visibleFacetItems.slice(accordionThreshold)"
							:key="index"
						>
							<CheckboxFacetItem
								:facet-key="facetKey"
								:facet-item="facetItem"
								class="flex justify-between"
							/>
						</template>
					</div>
				</template>
			</SlideDownAccordion>
		</ClientOnly>

		<div v-if="showContentLoader" class="flex flex-col gap-2">
			<!-- <ContentLoader viewBox="0 0 250 90">
				<rect x="0" y="0" rx="3" ry="3" width="100%" height="10" />
				<rect x="0" y="20" rx="3" ry="3" width="100%" height="10" />
				<rect x="0" y="40" rx="3" ry="3" width="100%" height="10" />
				<rect x="0" y="60" rx="3" ry="3" width="100%" height="10" />
				<rect x="0" y="80" rx="3" ry="3" width="100%" height="10" />
			</ContentLoader> -->
			<ContentLoader width="w-full" height="h-[10px]" />
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import SlideDownAccordion from '@/components/accordions/SlideDownAccordion.vue'
import CheckboxFacetItem from '@/components/product-catalog/facets/CheckboxFacetItem.vue'
import { useProductCatalog } from '@/stores/product-catalog'
import ContentLoader from '@/components/ContentLoader.vue'

const productCatalog = useProductCatalog()

const props = defineProps({
	facetKey: {
		type: String,
		required: true,
	},
	title: {
		type: String,
		required: true,
	},
	displayFirstLabels: {
		type: Array,
		default: () => [],
		required: false,
	},
	accordionThreshold: {
		type: Number,
		default: 5,
		required: false,
	},
	accordionClosedLabel: {
		type: String,
		default: 'Show all',
		required: false,
	},
	accordionOpenedLabel: {
		type: String,
		default: 'Show less',
		required: false,
	},
})

const facetItems = computed(() => productCatalog.facets[props.facetKey])

const orderedFacetItems = computed(() => {
	const displayFirstLabels = props.displayFirstLabels.map((label) =>
		`${label}`.toLowerCase()
	)
	const displayFirstItems = []

	displayFirstLabels.forEach((label) => {
		const facetItem = facetItems.value.find(
			(item) => `${item.label}`.toLowerCase().trim() === label
		)
		if (facetItem) {
			displayFirstItems.push(facetItem)
		}
	})

	return [
		...displayFirstItems,
		...facetItems.value.filter(
			(item) =>
				!displayFirstLabels.includes(
					`${item.label}`.toLowerCase().trim()
				)
		),
	]
})

const visibleFacetItems = computed(() =>
	orderedFacetItems.value.filter((faceItem) => canShowFacetItem(faceItem))
)

const canShow = computed(() => visibleFacetItems.value.length)

const activeFilters = computed(() => productCatalog.activeFilters)

const isDirty = computed(() => productCatalog.isDirty)

const showContentLoader = computed(() => !isDirty.value)

const canShowFacetItem = (facetItem) => {
	if (facetItem.count && parseInt(facetItem.count, 10) > 0) {
		return true
	}

	return false
}

const onClear = () => {
	productCatalog.removeFilter(props.facetKey)
}
</script>
